import {
  QuickLoginPromptTrackingPoint,
  ReloginQuickLoginTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const QuickLoginPromptTrackingSchema: Record<
  QuickLoginPromptTrackingPoint,
  string
> = {
  [QuickLoginPromptTrackingPoint.QuickLoginPromptPageView]:
    '02f8267b-e3b1-4af5-b060-b12de02ec965',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptEnableQuickLoginClick]:
    '6e485efa-800b-463a-8395-8f5c54fa5d61',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptBackClick]:
    '77c96bd8-8399-4136-bd91-f5c8769b4be3',
};

const ReloginQuickLoginTrackingSchema: Record<
  ReloginQuickLoginTrackingPoint,
  string
> = {
  [ReloginQuickLoginTrackingPoint.PageView]:
    '913ad381-9c27-45c9-9302-1f08a1d0466b',
  [ReloginQuickLoginTrackingPoint.ReloginWithOtherMethodsClick]:
    'a4ec52a4-a9c0-4372-815d-d3a97b01f076',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionImpression]:
    '42713d41-461f-4f3e-b1b1-9b34639b67a9',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionClick]:
    'b2042998-ba60-44f9-89cd-e85fd1133bdb',
  [ReloginQuickLoginTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginQuickLoginTrackingPoint.ReloginSignupClick]: '',
  [ReloginQuickLoginTrackingPoint.QuickLoginClick]:
    '23a2b576-b320-4698-9b4c-6e18abdd2f2d',
};

export const getQuickLoginPromptPageTypeAndSchema = (
  trackingPoint: QuickLoginPromptTrackingPoint
) => {
  return {
    page_type: PageType.QuickLoginPromptPage,
    schema: QuickLoginPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginQuickLoginPageTypeAndSchema = (
  trackingPoint: ReloginQuickLoginTrackingPoint
) => {
  return {
    page_type: PageType.ReloginQuickLoginPage,
    schema: ReloginQuickLoginTrackingSchema[trackingPoint],
  };
};
